export default __webpack_public_path__ + "static/media/7.455920f3.webp";